import { GraphQLResult } from '@aws-amplify/api-graphql';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreatePaymentStatusDownloadMutation, PaymentStatusDownload } from 'API';
import { graphqlRequest } from 'app/services/middleware';
import { RootState } from 'app/store/rootReducer';
import { graphqlOperation } from 'aws-amplify';
import { createPaymentStatusDownload } from 'graphql/mutations';
import moment from 'moment';

export interface DataExportState {
  download?: PaymentStatusDownload;
}

export const initialState: DataExportState = {
  download: undefined,
};

export interface PrepareDownloadArgs {
  userId: string;
  paidolId: string;
  startDate: Date;
  endDate: Date;
}

export const prepareDownload = createAsyncThunk(
  'payables/dataExport/prepareDownload',
  async ({ userId, paidolId, startDate, endDate }: PrepareDownloadArgs, { dispatch }) => {
    const clampedStartDate = moment()
      .year(startDate.getFullYear())
      .month(startDate.getMonth())
      .date(startDate.getDate())
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .toDate();

    const clampedEndDate = moment()
      .year(endDate.getFullYear())
      .month(endDate.getMonth())
      .date(endDate.getDate())
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .add(1, 'd')
      .toDate();

    return (
      graphqlRequest(
        graphqlOperation(createPaymentStatusDownload, {
          input: {
            user_id: userId,
            paidol_id: paidolId,
            start_date: clampedStartDate.toISOString(),
            end_date: clampedEndDate.toISOString(),
          },
        }),
        dispatch
      ) as Promise<GraphQLResult<CreatePaymentStatusDownloadMutation>>
    ).then((results) => {
      if (results?.data?.createPaymentStatusDownload) {
        dispatch(setDownload(results?.data?.createPaymentStatusDownload));
      }
    });
  }
);

const dataExportSlice = createSlice({
  name: 'payables/dataExport',
  initialState,
  reducers: {
    setDownload: (state, action: PayloadAction<PaymentStatusDownload | undefined>) => {
      state.download = action.payload;
    },
    resetDataExportSlice: () => initialState,
  },
});

export const selectDataExportSlice = (state: RootState) => state.payables?.dataExport ?? initialState;

export const { setDownload, resetDataExportSlice } = dataExportSlice.actions;

export default dataExportSlice.reducer;
